import variableNames, { variablePatterns } from '../constants/variable-names';

const variableNameToTrackingId = {
  [variableNames.BLOCK_BACKGROUND]: 'background-color',
  [variableNames.BLOCK_DIVIDER]: 'block-divider',
  [variableNames.BLOCKQUOTE]: 'quote',
  [variableNames.BORDER]: 'border',
  [variableNames.CONTACT_ICON]: 'contact-information-icons',
  [variableNames.DECORATION_BACKGROUND]: 'text-decorations',
  [variableNames.FEATURE_ICON]: 'feature-icons',
  [variableNames.FOOTER_NAV_LINK_TEXT]: 'footer-item-default',
  [variableNames.HEADER_PHONE]: 'header-phone',
  [variableNames.HEADING_1]: 'heading-1',
  [variableNames.HEADING_2]: 'heading-2',
  [variableNames.HEADING_3]: 'heading-3',
  [variableNames.HEADING_4]: 'heading-4',
  [variableNames.HEADING_5]: 'heading-5',
  [variableNames.HEADING_6]: 'heading-6',
  [variableNames.INPUT_BORDER]: 'input-border',
  [variableNames.INPUT_LABEL]: 'input-label',
  [variableNames.INPUT_TEXT]: 'input-text',
  [variableNames.LINK_TEXT]: 'text-link',
  [variableNames.MARK_TEXT]: 'mark-text',
  [variableNames.NAV_LINK]: 'item-default',
  [variableNames.NAV_LINK_ACTIVE]: 'item-active',
  [variableNames.OVERLAY_BACKGROUND]: 'background-overlay',
  [variableNames.PARAGRAPH]: 'paragraph',
  [variableNames.SITE_NAME]: 'site-name',
  [variableNames.SOCIAL_ICON]: 'social-icons',
};

const buttonEntries = [
  {
    pattern: variablePatterns.PRIMARY_BUTTON_BACKGROUND,
    trackingId: 'button-background',
  },
  { pattern: variablePatterns.PRIMARY_BUTTON_BORDER, trackingId: 'button-border' },
  { pattern: variablePatterns.PRIMARY_BUTTON_TEXT, trackingId: 'button-text' },
  {
    pattern: variablePatterns.SECONDARY_BUTTON_BACKGROUND,
    trackingId: 'button-background',
  },
  { pattern: variablePatterns.SECONDARY_BUTTON_BORDER, trackingId: 'button-border' },
  { pattern: variablePatterns.SECONDARY_BUTTON_TEXT, trackingId: 'button-text' },
];

const getVariableNameTrackingId = (variableName) => {
  const trackingId = variableNameToTrackingId[variableName];
  if (trackingId) return trackingId;

  const buttonEntry = buttonEntries.find(({ pattern }) => pattern.test(variableName));
  return buttonEntry ? buttonEntry.trackingId : null;
};

export default getVariableNameTrackingId;
